import React, { useState, useEffect, useContext } from "react";
import "./style.css";
import Amplitude from "amplitudejs";
import FavoriteIcon from "@material-ui/icons/Favorite";
import UnFavoriteIcon from "@material-ui/icons/FavoriteBorderOutlined";
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import GetAppIcon from '@mui/icons-material/GetApp';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
// import FavoriteIcon from "@material-ui/icons/Favorite";
// import UnFavoriteIcon from "@material-ui/icons/FavoriteBorderOutlined";
// import { ReactComponent as CreateNewFolderIcon } from "../../assets/folder_mediaPlayer.svg";
// import { ReactComponent as GetAppIcon } from "../../assets/download_mediaPlayer.svg";
// import { ReactComponent as Activedownload } from "../../assets/activedownload.svg";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";

import {
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
// import {ReactComponent as Success}  from '../../assets/success.svg';
import { ReactComponent as Points } from "../../assets/points.svg";
import API from "../../services/api";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
// import { toast } from 'react-toastify';
import TrackContext from "../../contexts/track-context";
import AddTrackToProjectPopup from "../Projects/addTrackToProjectPopup";
import { CardContent, CircularProgress } from "@material-ui/core";
// import { ReactComponent as Play } from "../../assets/player-play.svg";
// import { ReactComponent as Pause } from "../../assets/pause.svg";

import Play from '@mui/icons-material/PlayArrow';
import Pause from '@mui/icons-material/Pause';
import Rewind from '@mui/icons-material/Replay10';
import Skip from '@mui/icons-material/Forward10';
// import { ReactComponent as Rewind } from "../../assets/Rewind.svg";
// import { ReactComponent as Skip } from "../../assets/Skip.svg";
import CookieManager from "../../services/CookieManager";
import TrackDetail from "./track-detail";
import { ReactComponent as ThumbPrint } from "../../assets/auto_fix_high_black_18dp.svg";
import { BouncingLoader } from "../../pure-components/Loader";
import { toast } from "react-toastify";
import { ErrorToast, SuccessToast } from "../../pure-components/CustomToast";
import RippleLoader from "../../assets/loader-2.gif";
import Helper from "../../services/helper";
import defaultImage from "../../assets/default_music.png";
import Constants from "../../services/constants";
import { Link } from "react-router-dom";
import { SkipNext, SkipPrevious } from "@material-ui/icons";
import MewoService from "../../services/mewoService";
import { useHistory } from "react-router-dom";
import WaveformWithHighlights from "../../pure-components/SvgInLine/waveformWithHighlights";
import { JoinInner } from "@mui/icons-material";
import { DownloadIcon } from "../NewUI/icons";
import SaveAltIcon from '@mui/icons-material/SaveAlt';


export default function MediaPlay(props) {
  let trackContext = useContext(TrackContext);
  // console.log('[context] : ', trackContext.playPause);

  const history = useHistory();
  const [currentTrack, setCurrentTrack] = useState(trackContext.currentTrack);
  const [play, setPlay] = useState(true);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [downloadModalPosition, setDownloadModalPosition] = useState(null);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [hdmp3File, setHdmp3File] = useState(false);
  const [originalFile, setOriginalFile] = useState(false);
  const [trackToBeAddedToProject, setTrackToBeAddedToProject] = useState("");
  const [loaderAddTrackToProject, setLoaderAddTrackToProject] = useState(false);
  const [isFav, setIsFav] = useState(false);
  const [download, setDownload] = useState(false);
  const [showTrackDetail, setTrackDetail] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const filterMenu = trackContext.filterMenu;
  const [filterSubMenu, setFilterSubMenu] = useState([]);
  const [filterSubMenuChild, setFilterSubMenuchild] = useState([]);
  const [subMenu, setSubMenu] = useState("");
  const [value, setValue] = useState("");

  const [downloadingTrack, setDownloadingTrack] = useState("");
  const [favs, setFavs] = useState(Object.keys(JSON.parse(localStorage.getItem("favs") || "{}")) || []);
  const [addingFav, setAddingFav] = useState("");
  useEffect(() => {
    if (localStorage.getItem("favs") !== "undefined") {
      const favorites = JSON.parse(localStorage.getItem("favs") || "{}");
      if(Object.keys(favorites)?.length > 0){
        setFavs(Object.keys(favorites));
      }
    }
  }, []);

  useEffect(() => {
    if (showTrackDetail) {
      let navTag = document.getElementsByTagName("nav");
      if (navTag?.length > 0) {
        navTag[0].style.zIndex = 1;
      }
      let sidebarTag = document.querySelector(".sidebar");
      if (sidebarTag !== null) {
        sidebarTag.style.zIndex = 1;
      }
    } else {
      let navTag = document.getElementsByTagName("nav");
      if (navTag?.length > 0) {
        navTag[0].style.zIndex = 10;
      }
      

      let sidebarTag = document.querySelector(".sidebar");
      if (sidebarTag !== null) {
        sidebarTag.style.zIndex = 0;
      }
    }
  }, [showTrackDetail, showProjectModal]);

  useEffect(() => {
    // console.log('MEDIA PLAY CALLED',trackContext.currentTrackDetail);
    let artistName = "";
    if (
      typeof trackContext.currentTrackDetail.display_artists !== "undefined"
    ){
      artistName = Helper.getArtistName(trackContext.currentTrackDetail.display_artists);
    }else{
      artistName = trackContext.currentTrackDetail?.artist;
    }
    let volume = Amplitude.getVolume() > 0.5 ? Amplitude.getVolume() : 50;

    if (Amplitude.getSongs().length) {
      // console.log(' IF ')
      Amplitude.stop();
      Amplitude.removeSong(0);
      Amplitude.init({
        continue_next: false,
        volume: volume,
        songs: [
          {
            name: trackContext.currentTrackDetail.display_title,
            artist: artistName,
            album: "",
            url: currentTrack,
            cover_art_url: trackContext.currentTrackImage,
          },
        ],

        callbacks: {
          stop: function () {
            trackContext.setPlayPause(false)
          }
        },
        waveforms: {
          sample_rate: 1000
        }
      });
      Amplitude.bindNewElements();
      trackContext.setPlayPause(true);
      if (play) Amplitude.play();
    } else {
      setPlay(true);
      Amplitude.init({
        continue_next: false,
        volume: volume,
        songs: [
          {
            name: trackContext.currentTrackDetail.display_title,
            artist: artistName,
            album: "",
            url: trackContext.currentTrack,
            cover_art_url: trackContext.currentTrackImage,
          },
        ],

        callbacks: {
          stop: function () {
            trackContext.setPlayPause(false);
          }
        },
        waveforms: {
          sample_rate: 1000,
        },
      });
      Amplitude.pause();
      Amplitude.play();
      trackContext.setPlayPause(true);
    }
  }, [trackContext.currentTrackDetail]);

  useEffect(() => {
    let artistName = "";
    if (
      typeof trackContext.currentTrackDetail.display_artists !== "undefined"
    ){
      artistName = Helper.getArtistName(trackContext.currentTrackDetail.display_artists);
    }else{
      artistName = trackContext.currentTrackDetail?.artist;
    }
    Amplitude.setSongMetaData(0, {
      name: trackContext.currentTrackDetail.display_title,
      artist: artistName,
      cover_art_url: trackContext.currentTrackImage,
      id:trackContext.currentTrackDetail.id,
      album_id:trackContext?.currentTrackDetail?.album?.id
    });
    let favs = JSON.parse(localStorage.getItem("favs") || "{}");
    if (Object.keys(favs)?.length > 0) {
      if (Object.keys(favs).indexOf(trackContext.currentTrackDetail.id) !== -1) {
        setIsFav(true);
      } else {
        setIsFav(false);
      }
    }
    const downloadlist = JSON.parse(localStorage.getItem("download"));
    if (downloadlist !== null) {
      if (downloadlist.indexOf(trackContext.currentTrackDetail.id) !== -1) {
        setDownload(true);
      } else {
        setDownload(false);
      }
    }
    // console.log(download)
  }, [trackContext.currentTrackDetail, trackContext.currentTrackImage]);
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  // console.log("Amplitude", Amplitude)
  useEffect(() => {
    trackContext.playPause ? Amplitude.play() : Amplitude.pause();
    //  trackContext.setShowSubscribePopup(true);
    //   trackContext.setUserAction('Play');
  }, [trackContext.playPause]);

  useEffect(() => {
    if(Amplitude.getPlayerState() === 'stopped'){
      let index=trackContext.songData.findIndex(track=>track.id === Amplitude.getSongs()[0]?.id)
      if(index !== -1 && index <= trackContext.songData.length - 1){
        if(index === trackContext.songData.length - 1){
          return
        }
        Amplitude.stop();
        Amplitude.removeSong(0);
        playNextTrack(trackContext.songData[index + 1]?.id);
      }
    }
}, [trackContext.playPause])

//fetch and autoplay next track
const playNextTrack=async(trackId)=>{
  trackContext.setFetchingTrack(true);
  await API.playTrack(trackId).then(res => {
    if(res?.data?.success){
      if (Amplitude.getSongs().length) {
        Amplitude.stop();
        Amplitude.removeSong(0);
      }
      trackContext.setCurrentTrack(res.data.data.audiofile);
      trackContext.setCurrentTrackDetail({...res.data.data,...res.data.data.tags,
        artist: res.data.data.artists_publishing_ownerships[0]?.artist?.full_name,
        artist_type: res.data.data.artists_publishing_ownerships[0]?.rights_type?.key,});
      trackContext.setCurrentTrackImage(res.data.data.album?.image?.original?.url);
      trackContext.setPlayPause(true);
    }else{
      Helper.handleError(res);
    }
    trackContext.setFetchingTrack(false);
  })
  .catch(error=>{
    Helper.handleError(error)
  })
}

//function to fetch track and play next or prev track on button click
const handlePlayPrevNextTrack=async(action)=>{
  let trackId='';
  let songIndex=0;
  const {alltrackData,currentTrackDetail}=trackContext;

  let trackIndex=alltrackData.findIndex((track)=>{
    if(track?._id !== undefined){
      // checking this to work next prev functionality in history page and projects as there are duplicate tracks
      return track?.id ===currentTrackDetail?.id && track?._id === currentTrackDetail?.historyId  
    }
    else{
      return track?.id === currentTrackDetail?.id
    }
  });
  if(trackIndex === -1){
    return
  }
    if(action==="prev" && trackIndex !== 0)
    {
      trackId=alltrackData[trackIndex - 1]?.id;
      songIndex=trackIndex - 1
    }
    else if(action==="next" && trackIndex !== alltrackData.length - 1)
    {
      trackId=alltrackData[trackIndex + 1]?.id;
      songIndex=trackIndex + 1
    }
    else{
      return
    }
    trackContext.setFetchingTrack(true);
    await API.playTrack(trackId).then((res) => {
        trackContext.setFetchingTrack(false);
      if(res?.data?.success){
        if (Amplitude.getSongs().length) {
          Amplitude.stop();
          Amplitude.removeSong(0);
        }
          res.data.data['historyId']=alltrackData[songIndex]._id
          trackContext.setCurrentTrack(res.data.data.audiofile);
          trackContext.setCurrentTrackDetail({
            ...res.data.data,
            tags: res.data.data?.tags,
            artist: res.data.data?.artists_publishing_ownerships[0]?.artist?.full_name,
            artist_type: res.data.data?.artists_publishing_ownerships[0]?.rights_type?.key,
          });
      }else{
          Helper.handleError(res?.data);
        }
      })
      .catch((err) => {
        Helper.handleError(err); 
      });
}

  const handlePlayOrPause = () => {
    // play ? Amplitude.pause() : Amplitude.play();
    // setPlay(!play);
    trackContext.setPlayPause(!trackContext.playPause);
  };
  const handleClose = () => {
    setShowDownloadModal(false);
  };

  const handleDownloadTrackOld = (event, trackId) => {
    if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
      return;
    }
    let currentTarget = event.currentTarget;
    API.getDownloadTracks(trackId).then((res) => {
      if (res?.audiofile !== undefined && res.audiofile !== null) {
        setHdmp3File(res.audiofile.hd_mp3.url);
        setOriginalFile(res.audiofile.original.url);
        setShowDownloadModal(currentTarget);
      } else {
        Helper.handleError(res);
      }
    });

  };

  const handleDownloadClick = (event) => {
    setDownloadModalPosition(event.currentTarget);
    setShowDownloadModal(true);
  }
  const downloadTrack = async(trackId, format = "mp3") => {
    let cachedUserData = JSON.parse(CookieManager.getCookie("user-data"));
    if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
      return;
    }
    setDownloadingTrack(trackId);
      const filter = {
        "Identifier": trackId,
        "DownloadType": "track",
        "Format": format,
        "TrimStartSecs": 0,
        "TrimEndSecs": 0,
        "Email": cachedUserData.email,
        "IsShare": false,
        "Message": "",
        "SenderEmail": "",
        "ForceEmail": false,
        "IncludeVersions": false,
        "VersionFolderName": "",
        "DownloadFileName": "",
        "CuesheetFileName": "",
        "IncludeCuesheetFile": false
      }

      await API.downloadTrack(filter).then(resp => {
        if(resp.success){
          toast(({ closeToast }) => <SuccessToast message={"Request processed. Download will begin shortly."} />);
          // console.log("track download resp : ", resp);
          if(resp.data?.DownloadTokens?.length > 0){
            const accessURLs = JSON.parse(localStorage.getItem("resourceURL")|| "{}");
            if(accessURLs?.DirectDownloadURL?.length > 0){
              const downloadURL = accessURLs.DirectDownloadURL.replace("{downloadtoken}", resp.data.DownloadTokens[0].TokenValue)
              const link = document.createElement('a');
              link.href = downloadURL;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
        }
        else
          toast(({ closeToast }) => <ErrorToast message={"Track download Error : " + resp.mssg || resp.err} />);
      }).catch(err =>{
        // console.log("Track download error : ", err);
        toast(({ closeToast }) => <ErrorToast message={"Track download Error : " + err.mssg || err} />);
      }).finally(() => {
        setDownloadingTrack("");
      })

  };

  const handleDownloadArchive = (trackId, quality) => {
    API.downloadArchiveTrack(trackId, quality).then((res) => { });
  };

  const handleArchiveDownload = (trackId, quality) => {
    API.downloadArchiveTrack(trackId, quality).then((res) => {
      //success : response  = ["taskId"]
      //fail : response : { "status": 400, "message": "\"documentIds\" is required. \"docId\" is not allowed.", "key": "validation_error", "stack": {}, "reqId": "9022499d-9b2b-4edc-9397-c8f8372a83ea" }
      if (Array.isArray(res) && res.length) {
        toast(({ closeToast }) => (
          <SuccessToast message="Check your email, you have been sent a link to download the files." />
        ));
      } else {
      toast(({ closeToast }) => <ErrorToast message={res.message} />);
      }

    });
  };

  const setDownloadHistory = (trackId) => {
    API.setDownloads(trackId).then((res) => {
      //  console.log({ res });
      const downloadlist = JSON.parse(localStorage.getItem("download"));
      downloadlist.push(trackId);
      setDownload(downloadlist);
      localStorage.setItem("download", JSON.stringify(downloadlist));
    });
  };
  const closeProjectModal = () => {
    setShowProjectModal(false);
    setLoaderAddTrackToProject(false);
  };

  const handleProjectModal_old = (trackId) => {
    if (!trackContext.validateUser(Constants.ACTION.ADD_TO_PROJECT)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.ADD_TO_PROJECT);
      return;
    }

    setTrackToBeAddedToProject(trackId);
    setShowProjectModal(true);

  };

  const handleProjectModal = (trackId) => {
    if (!trackContext.validateUser(Constants.ACTION.ADD_TO_PROJECT)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.ADD_TO_PROJECT);
      return;
    }
    // props.displayProjectModal(trackId);
    
    trackContext.setTrackToBeAddedToProject(trackId);
    trackContext.setShowProjectModal(true);

  };

  const handleThumbPrintSearch = async(props) => {
    // if (!trackContext.validateUser(Constants.ACTION.SIMILARITY_SEARCH)) {
    //   trackContext.setShowSubscribePopup(true);
    //   trackContext.setUserAction(Constants.ACTION.SIMILARITY_SEARCH);
    //   return;
    // }
    let filter=trackContext.trackFilter
    filter.selectedChildTags=[]
    filter.selectedTags=[]
    filter.url=""
    filter.searchId="";
    filter.fileName="";
    filter.searchText = "";
    filter.searchTitle = props.currentTrackDetail.title;
    // filter.trackId=trackId;
    trackContext.setTrackFilter(filter);
    localStorage.setItem("filter_music" , JSON.stringify(filter))
    trackContext.setShowLoaderMagic(true);
    trackContext.setTrackData([]);
    
    if(trackContext.path.startsWith("/search")||
      trackContext.path==="/"|| 
      trackContext.path.startsWith("/albums") ||
      trackContext.path.startsWith("/artist") || 
      trackContext.path.startsWith("/playlists"))
    {
      history.push( `/search/track/`); 
    }
    let reqObj = {  
      url : 'public/search', 
      method : 'post', 
      data : {
        "query": "",
        "options": 
        {
            "trackId" : props.currentTrackDetail.id,
            "filters": {
              exclude: [],
              ...trackContext.trackFilter.searchTags,
            },
            "size": Constants.MEWO_TRACK_SEARCH_BATCH_SIZE,
            "search_descriptions":trackContext.searchDescription ? trackContext.searchDescription : false
        }
      }
    };
    await MewoService.loadMewoData(reqObj).then(res => {
          
      if (res?.hits) {
        let newRes = res.hits.filter(
          (item) => item.id !== props.currentTrackDetail.id
        );
        trackContext.setIsLoading(false);
        trackContext.setTrackData(newRes);
        trackContext.setTotaltracks(res.total.value);
      } else {
        Helper.handleError(res);
      }
    }).catch(err => {
      toast(({ closeToast }) => (
        <ErrorToast message={"Similarity Search Error : " + err?.response?.data?.message} />
      ));
    });
    trackContext.setShowLoaderMagic(false);
  };
const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl(null);
  };
  const handleAddTrackToFavorites = async(trackData) => {
    // console.log("fav track data", trackData);
    if (!trackContext.validateUser(Constants.ACTION.FAVOURITE)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.FAVOURITE);
      return;
    }
    setAddingFav(trackData.id);
    
    const dataObj = {
      actionType : Constants.ACTION.FAVOURITE,
      trackId : trackData.id,
      title : trackData.display_title,
      trackDesc : trackData.description || "",
      trackData : {
        albumId : trackData.album.id,
        albumName : trackData.album.name,
        artistName : trackData.artist,
        duration : trackData.duration,
        bpm : trackData.bpm
      }
    }
    
    await API.addTrackToFavorites(dataObj).then((res) => {
      if (res.success) {
        // const favs = JSON.parse(localStorage.getItem("favs") || "{}");
        // if(favs?.indexOf(trackData.trackId) < 0){
        //   favs.push(trackData.trackId)
        // }else{
        //   favs?.length > 0 && favs.splice(favs.indexOf(trackData.trackId), 1);
        // }

        localStorage.setItem("favs", JSON.stringify(res.favorites));
        setFavs(Object.keys(res.favorites));
        toast(({ closeToast }) => <SuccessToast message={res.mssg} />);
          
      } else {
        console.log("Adding in favorite list failed.", res);
        toast(({ closeToast }) => <ErrorToast message={"Adding in favorite list failed."} />);
      }
    }).catch(err => {
      console.log("Adding in favorite list failed.", err);
      toast(({ closeToast }) => <ErrorToast message={"Adding in favorite list failed."} />);
    }).finally(() => {
      setAddingFav("");
    });

  };

  const playNextPrevious = (skip) => {
    let playper =
      (Amplitude.getSongPlayedPercentage() / 100) *
      trackContext.currentTrackDetail.duration;
    let duration = playper + skip;
    let playerState = Amplitude.getPlayerState();
    let per = (duration / trackContext.currentTrackDetail.duration) * 100;
    /*if(duration<0)
    {
       Amplitude.skipTo(0,0, null);
    }
    else if(per>100)
    {
        Amplitude.setSongPlayedPercentage(99.99)
       trackContext.setPlayPause(false);
    }
    else
       Amplitude.setSongPlayedPercentage(per)
    if(!trackContext.playPause ){
      Amplitude.stop();
      Amplitude.skipTo(duration,0, null)
    }
    else
      Amplitude.play()*/
    // console.log(Amplitude)
    if (playerState === "playing" && per < 100) {
      Amplitude.setSongPlayedPercentage(duration < 0 ? 0.1 : per);
    } else {
      Amplitude.skipTo(
        per >= 100
          ? trackContext.currentTrackDetail.duration
          : per < 0
          ? 0
          : duration,
        0,
        null
      );
      trackContext.setPlayPause(false);
      Amplitude.stop();
    }

    //   Amplitude.skipTo(duration,0, null)
    /* if(trackIndex >-1 && trackIndex < trackContext.trackData.length)
    {
      if (Amplitude.getSongs().length) {
        Amplitude.stop()
        Amplitude.removeSong(0)
      }
      
  
    //  props.setFetchingTrack(true);
      API.playTrack(trackContext.trackData[trackIndex].id).then(res => {
       // props.setFetchingTrack(false);
       trackContext.setpreviousTrack(trackIndex--);
        trackContext.setCurrentTrack(res.data.data.audiofile)
        trackContext.setCurrentTrackDetail(res.data.data)
        trackContext.setCurrentTrackImage(res.data.data.album.image.xsmall.url);
      });
    }*/
  };

  const handleTrackDetail = () => {
    setTrackDetail(true);
    let body = document.getElementsByTagName("body");
    let navTag = document.getElementsByTagName("nav");
    navTag[0].style.zIndex = 10;
    // console.log({body});
    body[0].style.overflow = "hidden";
  };

  const CloseTrackDetail = () => {
    setTrackDetail(false);
    let body = document.getElementsByTagName("body");
    let navTag = document.getElementsByTagName("nav");
    navTag[0].style.zIndex = 20;
    // console.log({body});
    body[0].style.overflow = "auto";
  };

  const handleLoaderWithThumbPrint = () => {

    setShowLoader(true)
    trackContext.setClearData(true)
    handleThumbPrintSearch(props)
    trackContext.setClearData(false)


    // toast(({ closeToast }) => (
    //   <SuccessToast page='music' message="This is Maya, your self-learning neural engine. I am searching the most relevant tracks for you." />
    // ));

    // setTimeout(()=>setShowLoader(false),3000)
    setTimeout(() => {
      setShowLoader(false);
      // trackContext.setClearData(false)
    }, 4000)
    // let newTrackFilter = { ...trackContext.trackFilter };
    // newTrackFilter.searchText = "";
    // newTrackFilter.fetchList = true;
    // trackContext.setTrackFilter(newTrackFilter);
    // console.log('Remove Search Filter:', newTrackFilter);
    // localStorage.setItem("filter", JSON.stringify(newTrackFilter));
  }

  const handleMagicWandClick = (trackData) => {
    if (!trackContext.validateUser(Constants.ACTION.SEARCH)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.SEARCH);
      return;
    }
    //TODO : change this as we change musicFilter obj
    const tempFilter = CookieManager.getCookie("harmix-music-filter")?.length > 0 ? JSON.parse(decodeURIComponent(CookieManager.getCookie("harmix-music-filter"))) : { "searchText" : "", "type" : Constants.SEARCH_TYPE.text};
    tempFilter.type = Constants.SEARCH_TYPE.track;
    tempFilter.searchText = trackData.title;
    tempFilter.searchRef = trackData.id;
    tempFilter.segment = null;
    CookieManager.setCookie("harmix-music-filter", encodeURIComponent(JSON.stringify(tempFilter)));
    history.push(`/library/${trackData.id}`, {searchedTrackData : {...trackData}})
  }
  // const clearSearchTag = () => {
  //   let newTrackFilter = { ...trackContext.trackFilter };
  //   newTrackFilter.searchTags = {};
  //   newTrackFilter.selectedTags = [];
  //   newTrackFilter.duration = [];
  //   newTrackFilter.bpm = [];
  //   newTrackFilter.url = "";
  //   newTrackFilter.searchText = "";
  //   newTrackFilter.fetchList = true;
  //   trackContext.setTrackFilter(newTrackFilter);

  //   let newFilter = filterMenu.map((item) => {
  //     item.count = 0;
  //     return item;
  //   });
  //   trackContext.setFilterMenu(newFilter);
  //   localStorage.setItem("filterMenu", JSON.stringify(newFilter));
  //   setValue("");
  //   setFilterSubMenu([]);
  //   setFilterSubMenuchild([]);
  //   setSubMenu("");
  // };
 const [isExpanded, setIsExpanded] = useState(true);
  
  const toggleExpand = () => {
    console.log("Toggle clicked, current state:", isExpanded);
    setIsExpanded(prevState => !prevState);
  };
  
  // Debug effect to check state changes
  useEffect(() => {
    console.log("Expanded state changed to:", isExpanded);
  }, [isExpanded]);
  
  // Calculate the height to hide (keep only 48px visible)
  const playerHeight = isExpanded ? '0' : 'calc(100% - 0px)';
  

  return (
    <>

  {/* -------------Responsive Media Player------------- */}
<div className="player-wrapper hidden md:flex shadow-sm"
    style={{ transform: `translateY(${playerHeight})` }}
>
  {/* Toggle Arrow Button */}
  <div className="absolute -top-6 right-6 text-white rounded-t-md cursor-pointer" onClick={toggleExpand}>
    {isExpanded ? (
      <div
        style={{ backgroundColor: "rgb(var(--pink))" }}
        className="px-3 py-1 inline-block"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="rgb(var(--bg))" 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          className="text-white"
        >
          <polyline points="18 15 12 9 6 15"></polyline>
        </svg>
      </div>
    ) : (
      <div
        style={{backgroundColor: "rgb(var(--pink))"}}
        className="px-3 py-1 inline-block"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="rgb(var(--bg))" 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </div>
    )}
  </div>
  {currentTrack !== "" ? (
    <div
      id="blue-playlist-container"
      className="w-full flex items-center sm:px-6 md:px-2 mx-auto rounded-2xl py-1"
      style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))",boxShadow: "4px 4px 12px rgb(var(--shadow))", border: "1.5px solid rgb(var(--pink))" }}
    >
      <div
        id="progress-container"
        className="absolute top-0 md:hidden"
        style={{ marginTop: "-8px" }}
      >
        <input
          type="range"
          className="amplitude-song-slider block w-full"
        />
      </div>
  <Link className="pr-4 " to={`/album/${trackContext.currentTrackDetail.album?.id}`}>
  {
    trackContext.currentTrackDetail?.album ? 
    (
      <img
        src={trackContext.currentTrackDetail.album?.image.original.url}
        className="hidden lg:flex md:flex cursor-pointer"
        alt="music-img"
        width="100px"
        onError={(e)=>trackContext.setDefaultImage(e)}
      />
    ) : (
      <img
        src={defaultImage}
        className="hidden lg:flex md:flex cursor-pointer"
        alt="music-img"
        width="100px"
      />
    )
  }
</Link>

      <div id="amplitude-player" className="w-full h-full">
        <div id="amplitude-left" className="w-full">
          <div className="hidden sm:flex lg:w-2/12 md:w-1/5">
            <CardContent
              className="w-full self-center pb-16 text-left"
              style={{ paddingLeft: 0, paddingBottom: "15px", paddingRight: 0 }}
            >
              <div
                data-amplitude-song-info="name"
                className="media-t-title truncate"
              > </div>
              <div
                data-amplitude-song-info="artist"
                className="t-artist self-center"
              > </div>
            </CardContent>
          </div>
          <div id="player-left-bottom" className="w-9/12 ml-0 md:pr-0">
            <div
              id="control-container"
              className="w-1/12 self-center"
            >
              <div id="control-container" className="w-full">
                <div id="central-controls" className="flex w-full">
                  <div
                    className="track-play-pause flex w-full justify-center"
                    id="playpause"
                  >
                    {/* <div
                      aria-label="play/pause"
                      className="hidden sm:w-1/6 sm:outline-none sm:focus:outline-none sm:play-button sm:self-center sm:block"
                    >
                      <SkipPrevious
                        onClick={()=>handlePlayPrevNextTrack("prev")}
                        className="outline-none cursor-pointer hover:text-gray-500"
                        style={{
                          width: "20px",
                        }}
                        titleAccess="Previous"
                      />
                    </div> */}
                    <div
                      aria-label="play/pause"
                      className="hidden sm:outline-none sm:focus:outline-none sm:play-button sm:self-center sm:block"
                    >
                      <Rewind
                        onClick={() => playNextPrevious(-10)}
                        className="outline-none cursor-pointer"
                        style={{
                          width: "30px",
                        }}
                      />
                    </div>
                    <div
                      aria-label="play/pause"
                      className="outline-none focus:outline-none play-button self-center mx-2"
                      onClick={handlePlayOrPause}
                    >
                      {trackContext.playPause ? (
                        <Pause className="outline-none cursor-pointer" style={{
                          width: "30px",
                        }}/>
                      ) : (
                        <Play className="outline-none cursor-pointer" style={{
                          width: "30px",
                        }}/>
                      )}
                    </div>
                    <div
                      aria-label="play/pause"
                      className="outline-none focus:outline-none play-button self-center"
                    >
                      <Skip
                        className="outline-none cursor-pointer"
                        onClick={() => playNextPrevious(10)}
                        style={{
                          width: "30px",
                        }}
                      />
                    </div>
                    {/* <div
                      aria-label="play/pause"
                      className="hidden sm:w-1/6 sm:outline-none sm:focus:outline-none sm:play-button sm:self-center sm:block"
                    >
                      <SkipNext
                        onClick={()=>handlePlayPrevNextTrack("next")}
                        className="outline-none cursor-pointer hover:text-gray-500"
                        style={{
                          width: "20px",
                        }}
                        titleAccess="Next"
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex w-2/4 block sm:hidden">
              <CardContent
                className="w-full self-center text-left md:pl-0"
                style={{ paddingBottom: "15px" }}
              >
                <div
                  data-amplitude-song-info="name"
                  className="track-name text-base sm:mr-2 text-black truncate"
                > </div>
                <div
                  data-amplitude-song-info="artist"
                  className="track-artist text-xs self-center text-gray-700"
                > </div>
              </CardContent>
            </div>
            <span className="duration w-12 sm:w-0 sm:hidden self-center">
              <span className="amplitude-duration-minutes"></span>:
              <span className="amplitude-duration-seconds"></span>
            </span>
            <div
              className="flex justify-end py-8 text-center w-10 sm:w-0 sm:hidden cursor-pointer"
              onClick={handleTrackDetail}
            >
              <Points className="cursor-pointer" />
            </div>
            <div
              id="time-container"
              className="hidden lg:ml-0 md:ml-12 sm:w-8/12 md:block"
            >
              <span className="current-time font-light text-ctaRed">
                <span className="amplitude-current-minutes"></span>:
                <span className="amplitude-current-seconds"></span>
              </span>
              <div id="progress-container">
                {/* <div className="amplitude-wave-form"></div> */}
                <div className="w-full mt-0 " style={{"margin-top" : "-40px"}}>
                  <WaveformWithHighlights
                    waveformDataUrl={Helper.getWaveformDataURL( trackContext.currentTrackDetail.id)}
                    width={800}
                    height={100}
                    ranges={trackContext.currentTrackDetail.highlights?.length > 0 ? [...trackContext.currentTrackDetail.highlights] : []}
                    ID={ `${trackContext.currentTrackDetail.id}-play` }
                    duration={ trackContext.currentTrackDetail.duration }
                  />
                  
                </div>
                <input type="range" className="amplitude-song-slider" />
                <progress
                  id="song-played-progress"
                  className="amplitude-song-played-progress"
                ></progress>
                <progress
                  id="song-buffered-progress"
                  className="amplitude-buffered-progress"
                  value="0"
                  style={{display: 'none'}}
                ></progress>
              </div>
              <span className="duration">
                <span className="amplitude-duration-minutes"></span>:
                <span className="amplitude-duration-seconds"></span>
              </span>
            </div>
            <div
              id="control-container"
              className="sm:w-1/12 sm:block md:hidden lg:block self-center"
            >
              <div id="volume-container">
                <div className="volume-controls">
                  <div className="amplitude-mute amplitude-not-muted"></div>
                  <input
                    type="range"
                    className="amplitude-volume-slider"
                  />
                  <div className="ms-range-fix"></div>
                </div>
                <div
                  className="amplitude-shuffle amplitude-shuffle-off"
                  id="shuffle-right"
                ></div>
              </div>
            </div>
            <div
              className=" self-center justify-right flex h-4 ml-4 gap-x-2" 
            >
              {!trackContext.currentTrackDetail.isVersion &&
                <span className="w-8 lg:m-0 sm:mr-4 pt-1 self-center cursor-pointer hover:text-blue-600"
                  onClick={() => {handleMagicWandClick({
                    title: trackContext.currentTrackDetail.display_title, 
                    id:trackContext.currentTrackDetail.id,
                    albumId : trackContext.currentTrackDetail.album?.id, 
                    artist : trackContext.currentTrackDetail.artist, 
                    duration : trackContext.currentTrackDetail.duration
                  })}}
                  title = "Similar Search">
                {Helper.getSearchIcon("rgb(var(--text))")}
                </span>
                // <JoinInner
                //   className="self-center cursor-pointer hover:text-blue-600"
                //   onClick={() => {handleMagicWandClick({
                //     title: trackContext.currentTrackDetail.display_title, 
                //     id:trackContext.currentTrackDetail.id,
                //     albumId : trackContext.currentTrackDetail.album?.id, 
                //     artist : trackContext.currentTrackDetail.artist, 
                //     duration : trackContext.currentTrackDetail.duration
                //   })}}
                //   style={{ fontSize: "24px"}}
                // />
              }

              {showLoader ? (
                <div className="modal-busy" overflow="hidden">
                  <div>
                    <div className="center-busy loader-text-tag" overflow="hidden">
                      <div className="loader-text">
                        This is Maya, your self-learning neural engine. I am searching the most relevant tracks for you
                      </div>
                      <img src={RippleLoader} alt="loading..." className="onMobile img-tag" />
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {favs?.indexOf(props.currentTrackDetail.id) > -1 ? (
                <FavoriteIcon
                  onClick={() =>
                    handleAddTrackToFavorites(props.currentTrackDetail)
                  }
                  style={{ fontSize: "24px"}}
                  className="self-center cursor-pointer text-red-600 block"
                />
              ) : (
                <UnFavoriteIcon
                  onClick={() =>
                    handleAddTrackToFavorites(props.currentTrackDetail)
                  }
                  style={{ fontSize: "24px"}}
                  className="self-center cursor-pointer hover:text-red-600 block"
                />
              )}

              <CreateNewFolderOutlinedIcon
                style={{ fontSize: "24px"}}
                onClick={() =>
                  handleProjectModal({trackId : trackContext.currentTrackDetail.id, albumId : trackContext.currentTrackDetail.album?.id, artworkRef : Helper.getArtworkURL(trackContext.currentTrackDetail.album?.id), audioRef : Helper.playTrackURL(trackContext.currentTrackDetail.id)})
                }
                className="self-center cursor-pointer block hover:text-blue-600"
              />

              {download ? (
                <DownloadForOfflineIcon
                  onClick={(event) =>
                    handleDownloadClick(event)
                  }
                  style={{ fontSize: "24px"}}
                  className="hidden self-center cursor-pointer block"
                />
              ) : (
                <SaveAltIcon
                  onClick={(event) =>
                    handleDownloadClick(event)
                  }
                  style={{ fontSize: "24px"}}
                  className="self-center cursor-pointer block hover:text-blue-600"
                />
              )}

              <Menu
                id="customized-menu"
                anchorEl={downloadModalPosition}
                open={Boolean(showDownloadModal)}
                onClose={handleClose}
                style={{ width: "320px" }}
              >
                <MenuItem
                  onClick={() => { downloadTrack(props.currentTrackDetail.id, "aiff"); setShowDownloadModal(false) }}
                  className="card-action"
                >
                  <span className="card-action-text">
                    AIFF
                  </span>
                </MenuItem>
                <MenuItem
                  onClick={() => { downloadTrack(props.currentTrackDetail.id, "mp3"); setShowDownloadModal(false) }}
                  className="card-action"
                >
                  <span className="card-action-text">
                    MP3
                  </span>
                </MenuItem>
                <MenuItem
                  onClick={() => { downloadTrack(props.currentTrackDetail.id, "wav"); setShowDownloadModal(false) }}
                  className="card-action"
                >
                  <span className="card-action-text">
                    WAV
                  </span>
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null}
</div>

      {/* ------------------------Mobile---------------- */}
 <div 
      className="player-wrapper lg:hidden md:hidden  flex flex-col xshadow-md p-3 text-sm w-full fixed bottom-0 left-0 right-0 z-50 transition-all duration-300"
      style={{ transform: `translateY(${playerHeight})`, backgroundColor: "rgb(var(--canvas))", color: "rgb(var(--text))", }}
    >
      {/* Toggle Arrow Button */}
   <div className="absolute -top-6 right-6  text-white rounded-t-md  cursor-pointer" onClick={toggleExpand}
>
    {isExpanded ? (
    <div
  style={{ backgroundColor: "#E30185" }}
  className="px-3 py-1 inline-block"
>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="16" 
    height="16" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className="text-white"
  >
    <polyline points="18 15 12 9 6 15"></polyline>
  </svg>
</div>

    ) : (
    <div
           style={{backgroundColor : "black"}}
             className="px-3 py-1 inline-block"
    >
        <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
      </  div>
    )}
  </div>
      
{/* Top Time & Waveform */}
<div className="mobilewave overflow-y-hidden relative"> 
  


      {/* Player Controls & Track Info */}
      <div className="flex items-center justify-around mb-4">
        {/* Album Art */}
        <Link to={`/album/${trackContext.currentTrackDetail.album?.id}`} className="lg:flex md:flex flex-shrink-0">
          <img
            src={trackContext.currentTrackDetail.album?.image?.original?.url || defaultImage}
            alt="Album"
            className="w-16  h-16  object-cover rounded-md shadow border-2 border-white"
            onError={(e) => trackContext.setDefaultImage(e)}
          />
        </Link>

        {/* Track Info */}
        <CardContent
  className="  self-center ml-1  pb-16 text-left"
  style={{ paddingLeft: 0, paddingBottom: "15px", paddingRight: 0,minWidth: "0" }}
>

  <div className="flex-1 min-w-0">
    <div className="text-xs sm:text-base truncate">
      {trackContext.currentTrackDetail.display_title}
    </div>
    {/* <div className="text-xs text-gray-600 truncate">
      {trackContext.currentTrackDetail.artist}
    </div> */}
  </div>


  {/* <div className="flex-1 min-w-0">
  <div className="text-sm font-semibold text-black truncate">
    {trackContext.currentTrackDetail?.title &&
      (trackContext.currentTrackDetail.title.length > 1
        ? `${trackContext.currentTrackDetail.title.slice(0, 10)}...`
        : trackContext.currentTrackDetail.title)}
  </div>

  <div className="text-xs text-gray-600 truncate">
    {trackContext.currentTrackDetail?.artist &&
      (trackContext.currentTrackDetail.artist.length > 10
        ? `${trackContext.currentTrackDetail.artist.slice(0, 10)}...`
        : trackContext.currentTrackDetail.artist)}
  </div>
</div> */}

</CardContent>


        {/* Player Controls */}
        <div className="flex items-center  ml-1 gap-2">
          {/* <div
            onClick={() => handlePlayPrevNextTrack("prev")}
            className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition cursor-pointer"
          >
            <SkipPrevious className="w-4 h-4" />
          </div> */}
  <div
                            aria-label="play/pause"
                            className=" sm:w-1/6 sm:outline-none sm:focus:outline-none sm:play-button sm:self-center sm:block"
                            //  onClick={handlePlayOrPause}
                          >
                            <Rewind
                              onClick={() => playNextPrevious(-10)}
                              className="outline-none cursor-pointer"
                              style={{
                                color: "rgb(var(--pink))",
                                width: "20px",
                              }}
                            />
                          </div>
          <div
            onClick={handlePlayOrPause}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-200 text-black transition cursor-pointer"
          >
            {trackContext.playPause ? (
              <Pause className="w-5 h-5" style={{color: "rgb(var(--pink))",}}/>
            ) : (
              <Play className="w-5 h-5" style={{color: "rgb(var(--pink))",}}/>
            )}
          </div>
  <div
                            aria-label="play/pause"
                            className=" sm:w-1/6 outline-none focus:outline-none play-button self-center sm:ml-1"
                            //  onClick={handlePlayOrPause}
                          >
                            <Skip
                              className="outline-none cursor-pointer"
                              onClick={() => playNextPrevious(10)}
                              style={{
                                color: "rgb(var(--pink))",
                                width: "20px",
                              }}
                            />
                          </div>
          {/* <div
            onClick={() => handlePlayPrevNextTrack("next")}
            className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition cursor-pointer"
          >
            <SkipNext className="w-4 h-4" />
          </div> */}
        </div>
<div className="flex justify-between ml-1 flex-wrap w-[70%] text-xs">
            <span className="current-time  font-light text-ctaRed">
              <span className="amplitude-current-minutes"></span>:
              <span className="amplitude-current-seconds"></span>
        {/* <span>/</span>
              <span className="amplitude-duration-minutes"></span>:
              <span className="amplitude-duration-seconds"></span> */}
            </span>
          </div>
        {/* Action Icons */}
       <div className="flex items-start relative">
    {/* 3-dot menu icon */}
<div>
      <IconButton onClick={handleClick} style={{ padding: 4 }}>
        <MoreVertIcon style={{ fontSize: 20, color: "rgb(var(--text))" }} />
      </IconButton>
<Menu
  anchorEl={anchorEl}
  open={open}
  onClose={handleClose2}
  PaperProps={{
    elevation: 4,
    style: {
      borderRadius: 10,
      paddingTop: 4,
      paddingBottom: 4,
      marginLeft: "-20px", // custom shift for spacing
      background: "rgb(var(--canvas))",
      bottom: "10px",
      right: "30px",
      width: "70px"
    },
  }}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "right",
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "right",
  }}
>
  {!trackContext.currentTrackDetail.isVersion &&
    <MenuItem
       onClick={() => {handleMagicWandClick({
                    title: trackContext.currentTrackDetail.display_title, 
                    id:trackContext.currentTrackDetail.id,
                    albumId : trackContext.currentTrackDetail.album?.id, 
                    artist : trackContext.currentTrackDetail.artist, 
                    duration : trackContext.currentTrackDetail.duration
                  }); handleClose2();}}
      >
      {/* <ListItemIcon>
        <ThumbPrint  className="thumbprint-icon w-8 sm:w-6 sm:mb-4 sm:mt-5 sm:ml-2 sm:right-0 self-center cursor-pointer"
                          // onClick={
                          //   handleLoaderWithThumbPrint
                          //   // handleThumbPrintSearch(props.currentTrackDetail.id)

                          // }
                        
                      />
      </ListItemIcon> */}
      <ListItemIcon>
        {/* <JoinInner /> */}
        {Helper.getSearchIcon("rgb(var(--text))")}
      </ListItemIcon>

      {/* <ListItemText primary="Magic Wand" /> */}
    </MenuItem> 
  }
  <MenuItem 
    onClick={() =>{
                        handleProjectModal({trackId : trackContext.currentTrackDetail.id, albumId : trackContext.currentTrackDetail.album?.id, artworkRef : Helper.getArtworkURL(trackContext.currentTrackDetail.album?.id), audioRef : Helper.playTrackURL(trackContext.currentTrackDetail.id)});
                         handleClose2();
       }   }>
    <ListItemIcon>
      <CreateNewFolderOutlinedIcon
                      style={{ fontSize: "28px", color: "rgb(var(--text))" }}
                    
                      className="m-1 self-center right-0 cursor-pointer text-gray-700 block"
                   />
    </ListItemIcon>
    {/* <ListItemText primary="Add to project" /> */}
  </MenuItem>
{/* <MenuItem
onClick={() => handleAddTrackToFavorites(props.trackId)}
> */}
  {/* <ListItemIcon>
    {isFav ? (
      <FavoriteIcon
        fontSize="small"
        className="text-red-600 hover:scale-110 transition-transform duration-200"
      />
    ) : (
      <UnFavoriteIcon
        fontSize="small"
        className="text-gray-600 hover:text-red-600 transition-colors duration-200"
      />
    )}
  </ListItemIcon>
  <ListItemText primary={isFav ? "Unfavourite" : "Favourite"} /> */}
{/* <ListItemButton > */}
  {/* <ListItemText primary={isFav ? "Unfavourite" : "Favourite"} /> */}
{/* </ListItemButton> */}
{/* </MenuItem> */}

<MenuItem
  onClick={() => {
    handleAddTrackToFavorites(props.currentTrackDetail);
    handleClose2();
  }}
>
  <ListItemIcon>
    {favs?.indexOf(props.currentTrackDetail.id) > -1 ? (
      <FavoriteIcon
        // fontSize="medium"
        className="text-red-600 self-center right-0 m-1 cursor-pointer hover:scale-110 transition-transform duration-200"
        style={{fontSize: "28px"}}
      />
    ) : (
      <UnFavoriteIcon
        // fontSize="medium"
        className="self-center right-0 cursor-pointer m-1 hover:text-red-600 transition-colors duration-200"
        style={{fontSize: "28px", color: "rgb(var(--text))"}}
      />
    )}
  </ListItemIcon>
  {/* <ListItemText primary={isFav ? "Unfavourite" : "Favourite"} /> */}
</MenuItem>

<MenuItem
  onClick={(event) => {
    handleDownloadClick(event);
    handleClose2();
  }}
>
  <ListItemIcon>
    {download ? (
      downloadingTrack?.length > 0 ? 
      <div className="pt-2" ><CircularProgress size='18px'/></div> : 
      <DownloadForOfflineIcon
        // fontSize="small"
        className="self-center right-0 cursor-pointer m-1 transition-colors duration-200"
        style={{fontSize: "28px", color: "rgb(var(--text))"}}
      />
    ) : (
      downloadingTrack?.length > 0 ? 
      <div className="pt-2" ><CircularProgress size='18px'/></div> : 
      <GetAppIcon
        // fontSize="small"
        className="self-center right-0 cursor-pointer m-1 transition-colors duration-200"
        style={{fontSize: "28px", color: "rgb(var(--text))"}}
      />
    )}
  </ListItemIcon>
  {/* <ListItemText primary="Download" /> */}
</MenuItem>

</Menu>
    </div>

    </div>
      </div>

      <div className="flex rounded-md px-2  py-2 mb-2">
        <div className="w-full flex flex-col justify-center h-[40px] overflow-hidden items-center gap-2">
          <div className="w-full flex-1  " id="progress-container">
            {/* <div className="amplitude-wave-form relative w-full mt-0 rounded-full "> */}
            {/* Amplitude injects SVG here */}
            <div className="w-full mt-0 " style={{"margin-top" : "-30px"}}>
              <WaveformWithHighlights
                waveformDataUrl={Helper.getWaveformDataURL( trackContext.currentTrackDetail.id)}
                width={800}
                height={80}
                ranges={trackContext.currentTrackDetail.highlights?.length > 0 ? [...trackContext.currentTrackDetail.highlights] : []}
                ID={ `${trackContext.currentTrackDetail.id}-play` }
                duration={ trackContext.currentTrackDetail.duration }
                baseFill = {"rgb(var(--pink))"}
                highlightFill = {"rgb(var(--green))"}
                stroke = {"rgb(var(--pink))"}
              />
              
            </div>
            
            <input
              type="range"
              className="amplitude-song-slider -mt-2 w-full"
            />
            <progress
              id="song-played-progress"
              className="amplitude-song-played-progress w-full"
            />
            <progress
              id="song-buffered-progress"
              value="0"
              className="amplitude-buffered-progress hidden"
            />
          </div>

          {/* Time display goes here if needed */}
        </div>
      </div>
      </div>
      {/* Loader */}
      {showLoader && (
        <div className="mt-2 text-center text-xs text-gray-600">
          <p className="mb-1">This is Maya, searching the most relevant tracks for you</p>
          <img src={RippleLoader} alt="loading..." className="mx-auto h-4" />
        </div>
      )}

      {/* Modals
      {showProjectModal && (
        <AddTrackToProjectPopup
          trackToBeAddedToProject={trackToBeAddedToProject}
          closeProjectModal={closeProjectModal}
        />
      )}
      {showTrackDetail && (
        <TrackDetail
          currentTrackDetail={props}
          handleProjectModal={handleProjectModal}
          CloseTrackDetail={CloseTrackDetail}
        />
      )} */}
    </div>
      {showProjectModal && (
        <AddTrackToProjectPopup
          trackToBeAddedToProject={trackToBeAddedToProject}
          closeProjectModal={closeProjectModal}
        />
      )}
      {showTrackDetail && (
        <TrackDetail
          currentTrackDetail={props}
          handleProjectModal={handleProjectModal}
          CloseTrackDetail={CloseTrackDetail}
        />
      )}
    </>
  );
}



// }
// import React, { useState, useEffect, useContext } from "react";
// import "./style.css";
// import Amplitude from "amplitudejs";
// import FavoriteIcon from "@material-ui/icons/Favorite";
// import UnFavoriteIcon from "@material-ui/icons/FavoriteBorderOutlined";
// import { ReactComponent as CreateNewFolderIcon } from "../../assets/folder_mediaPlayer.svg";
// import { ReactComponent as GetAppIcon } from "../../assets/download_mediaPlayer.svg";
// import { ReactComponent as Activedownload } from "../../assets/activedownload.svg";

// import { ReactComponent as Points } from "../../assets/points.svg";
// import API from "../../services/api";
// import Menu from "@material-ui/core/Menu";
// import MenuItem from "@material-ui/core/MenuItem";
// import TrackContext from "../../contexts/track-context";
// import AddTrackToProjectPopup from "../Projects/addTrackToProjectPopup";
// import { CardContent } from "@material-ui/core";
// import { ReactComponent as Play } from "../../assets/player-play.svg";
// import { ReactComponent as Pause } from "../../assets/pause.svg";
// import { ReactComponent as Rewind } from "../../assets/Rewind.svg";
// import { ReactComponent as Skip } from "../../assets/Skip.svg";
// import CookieManager from "../../services/CookieManager";
// import TrackDetail from "./track-detail";
// import { ReactComponent as ThumbPrint } from "../../assets/auto_fix_high_black_18dp.svg";
// import { BouncingLoader } from "../../pure-components/Loader";
// import { toast } from "react-toastify";
// import { ErrorToast, SuccessToast } from "../../pure-components/CustomToast";
// import RippleLoader from "../../assets/loader-2.gif";
// import Helper from "../../services/helper";
// import defaultImage from "../../assets/default_music.png";
// import Constants from "../../services/constants";
// import { Link } from "react-router-dom";
// import { SkipNext, SkipPrevious, VolumeUp, VolumeOff, Shuffle } from "@material-ui/icons";
// import MewoService from "../../services/mewoService";
// import { useHistory } from "react-router-dom";

// export default function MediaPlay(props) {
//   let trackContext = useContext(TrackContext);

//   const history = useHistory();
//   const [currentTrack, setCurrentTrack] = useState(trackContext.currentTrack);
//   const [play, setPlay] = useState(true);
//   const [showProjectModal, setShowProjectModal] = useState(false);
//   const [showDownloadModal, setShowDownloadModal] = useState(false);
//   const [hdmp3File, setHdmp3File] = useState(false);
//   const [originalFile, setOriginalFile] = useState(false);
//   const [trackToBeAddedToProject, setTrackToBeAddedToProject] = useState("");
//   const [loaderAddTrackToProject, setLoaderAddTrackToProject] = useState(false);
//   const [isFav, setIsFav] = useState(false);
//   const [download, setDownload] = useState(false);
//   const [showTrackDetail, setTrackDetail] = useState(false);
//   const [showLoader, setShowLoader] = useState(false);
//   const [isMuted, setIsMuted] = useState(false);
//   const [currentVolume, setCurrentVolume] = useState(50);
//   const [previousVolume, setPreviousVolume] = useState(50); // Store previous volume when muting
//   const filterMenu = trackContext.filterMenu;
//   const [filterSubMenu, setFilterSubMenu] = useState([]);
//   const [filterSubMenuChild, setFilterSubMenuchild] = useState([]);
//   const [subMenu, setSubMenu] = useState("");
//   const [value, setValue] = useState("");
//    const [isOpen, setIsOpen] = useState(false);

//   // Fixed z-index management
//   useEffect(() => {
//     if (showTrackDetail) {
//       let navTag = document.getElementsByTagName("nav");
//       if (navTag && navTag.length > 0) {
//         navTag[0].style.zIndex = 1;
//       }

//       let sidebarTag = document.querySelector(".sidebar");
//       if (sidebarTag !== null) {
//         sidebarTag.style.zIndex = 10; // Set higher z-index for sidebar
//       }
//     } else {
//       let navTag = document.getElementsByTagName("nav");
//       if (navTag && navTag.length > 0) {
//         navTag[0].style.zIndex = 10;
//       }

//       let sidebarTag = document.querySelector(".sidebar");
//       if (sidebarTag !== null) {
//         sidebarTag.style.zIndex = 10; // Keep sidebar visible
//       }
//     }
//   }, [showTrackDetail, showProjectModal]);

//   useEffect(() => {
//     let artistName = "";
//     if (
//       typeof trackContext.currentTrackDetail.display_artists !== "undefined"
//     ) {
//       artistName = trackContext.currentTrackDetail?.artist;
//     }
//     let volume = Amplitude.getVolume() > 0.5 ? Amplitude.getVolume() : 50;
//     setCurrentVolume(volume * 100);
//     setPreviousVolume(volume * 100);

//     if (Amplitude.getSongs().length) {
//       Amplitude.stop();
//       Amplitude.removeSong(0);
//       Amplitude.init({
//         continue_next: false,
//         volume: volume,
//         songs: [
//           {
//             name: trackContext.currentTrackDetail.display_title,
//             artist: artistName,
//             album: "",
//             url: currentTrack,
//             cover_art_url: trackContext.currentTrackImage,
//           },
//         ],

//         callbacks: {
//           stop: function () {
//             trackContext.setPlayPause(false)
//           }
//         },
//         waveforms: {
//           sample_rate: 1000
//         }
//       });
//       Amplitude.bindNewElements();
//       trackContext.setPlayPause(true);
//       if (play) Amplitude.play();
//     } else {
//       setPlay(true);
//       Amplitude.init({
//         continue_next: false,
//         volume: volume,
//         songs: [
//           {
//             name: trackContext.currentTrackDetail.display_title,
//             artist: artistName,
//             album: "",
//             url: trackContext.currentTrack,
//             cover_art_url: trackContext.currentTrackImage,
//           },
//         ],

//         callbacks: {
//           stop: function () {
//             trackContext.setPlayPause(false);
//           }
//         },
//         waveforms: {
//           sample_rate: 1000,
//         },
//       });
//       Amplitude.pause();
//       Amplitude.play();
//       trackContext.setPlayPause(true);
//     }
//   }, [trackContext.currentTrackDetail]);

//   useEffect(() => {
//     let artistName = "";
//     if (
//       typeof trackContext.currentTrackDetail.display_artists !== "undefined"
//     ) {
//       artistName = trackContext.currentTrackDetail?.artist;
//     }
//     Amplitude.setSongMetaData(0, {
//       name: trackContext.currentTrackDetail.display_title,
//       artist: artistName,
//       cover_art_url: trackContext.currentTrackImage,
//       id: trackContext.currentTrackDetail.id,
//       album_id: trackContext?.currentTrackDetail?.album?.id
//     });
//     let favs = JSON.parse(localStorage.getItem("favs"));
//     if (favs !== null) {
//       if (favs.indexOf(trackContext.currentTrackDetail.id) !== -1) {
//         setIsFav(true);
//       } else {
//         setIsFav(false);
//       }
//     }
//     const downloadlist = JSON.parse(localStorage.getItem("download"));
//     if (downloadlist !== null) {
//       if (downloadlist.indexOf(trackContext.currentTrackDetail.id) !== -1) {
//         setDownload(true);
//       } else {
//         setDownload(false);
//       }
//     }
//   }, [trackContext.currentTrackDetail, trackContext.currentTrackImage]);

//   useEffect(() => {
//     trackContext.playPause ? Amplitude.play() : Amplitude.pause();
//   }, [trackContext.playPause]);

//   useEffect(() => {
//     if(Amplitude.getPlayerState() === 'stopped'){
//       let index = trackContext.songData.findIndex(track => track.id === Amplitude.getSongs()[0]?.id)
//       if(index !== -1 && index <= trackContext.songData.length - 1){
//         if(index === trackContext.songData.length - 1){
//           return
//         }
//         Amplitude.stop();
//         Amplitude.removeSong(0);
//         playNextTrack(trackContext.songData[index + 1]?.id);
//       }
//     }
//   }, [trackContext.playPause]);

//   // Fixed mute functionality
//   const handleMute = () => {
//     if (isMuted) {
//       // Unmute: restore to previous volume
//       Amplitude.setVolume(previousVolume / 100);
//       setCurrentVolume(previousVolume);
//     } else {
//       // Mute: save current volume and set to 0
//       setPreviousVolume(currentVolume);
//       Amplitude.setVolume(0);
//       setCurrentVolume(0);
//     }
//     setIsMuted(!isMuted);
//   };

//   // Enhanced volume change handler
//   const handleVolumeChange = (e) => {
//     const volume = parseInt(e.target.value, 10);
//     setCurrentVolume(volume);
//     Amplitude.setVolume(volume / 100);
    
//     // Update mute state based on volume
//     if (volume === 0) {
//       if (!isMuted) {
//         setIsMuted(true);
//       }
//     } else {
//       if (isMuted) {
//         setIsMuted(false);
//       }
//       // Always update previous volume when changing to non-zero
//       setPreviousVolume(volume);
//     }
//   };

//   const playNextTrack = async(trackId) => {
//     trackContext.setFetchingTrack(true);
//     await API.playTrack(trackId).then(res => {
//       if(res?.data?.success){
//         if (Amplitude.getSongs().length) {
//           Amplitude.stop();
//           Amplitude.removeSong(0);
//         }
//         trackContext.setCurrentTrack(res.data.data.audiofile);
//         trackContext.setCurrentTrackDetail({...res.data.data,...res.data.data.tags,
//           artist: res.data.data.artists_publishing_ownerships[0]?.artist?.full_name,
//           description: res.data.data.artists_publishing_ownerships[0]?.description?.description,
//           artist_type: res.data.data.artists_publishing_ownerships[0]?.rights_type?.key,});
//         trackContext.setCurrentTrackImage(res.data.data.album?.image?.original?.url);
//         trackContext.setPlayPause(true);
//       }else{
//         Helper.handleError(res);
//       }
//       trackContext.setFetchingTrack(false);
//     })
//     .catch(error=>{
//       Helper.handleError(error)
//     })
//   }

//   const handlePlayPrevNextTrack = async(action) => {
//     let trackId='';
//     let songIndex=0;
//     const {alltrackData,currentTrackDetail} = trackContext;

//     let trackIndex = alltrackData.findIndex((track) => {
//       if(track?._id !== undefined){
//         // checking this to work next prev functionality in history page and projects as there are duplicate tracks
//         return track?.id === currentTrackDetail?.id && track?._id === currentTrackDetail?.historyId  
//       }
//       else{
//         return track?.id === currentTrackDetail?.id
//       }
//     });
    
//     if(trackIndex === -1){
//       return
//     }
    
//     if(action === "prev" && trackIndex !== 0) {
//       trackId = alltrackData[trackIndex - 1]?.id;
//       songIndex = trackIndex - 1
//     }
//     else if(action === "next" && trackIndex !== alltrackData.length - 1) {
//       trackId = alltrackData[trackIndex + 1]?.id;
//       songIndex = trackIndex + 1
//     }
//     else{
//       return
//     }
    
//     trackContext.setFetchingTrack(true);
//     await API.playTrack(trackId).then((res) => {
//       trackContext.setFetchingTrack(false);
//       if(res?.data?.success){
//         if (Amplitude.getSongs().length) {
//           Amplitude.stop();
//           Amplitude.removeSong(0);
//         }
//         res.data.data['historyId'] = alltrackData[songIndex]._id
//         trackContext.setCurrentTrack(res.data.data.audiofile);
//         trackContext.setCurrentTrackDetail({
//           ...res.data.data,
//           tags: res.data.data?.tags,
//           artist: res.data.data?.artists_publishing_ownerships[0]?.artist?.full_name,
//           description: res.data.data.artists_publishing_ownerships[0]?.description?.description,
//           artist_type: res.data.data?.artists_publishing_ownerships[0]?.rights_type?.key,
//         });
//       } else {
//         Helper.handleError(res?.data);
//       }
//     })
//     .catch((err) => {
//       Helper.handleError(err); 
//     });
//   }

//   const handlePlayOrPause = () => {
//     trackContext.setPlayPause(!trackContext.playPause);
//   };
  
//   const handleClose = () => {
//     setShowDownloadModal(false);
//   };

//   const handleDownloadTrack = (event, trackId) => {
//     if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
//       trackContext.setShowSubscribePopup(true);
//       trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
//       return;
//     }
//     let currentTarget = event.currentTarget;
//     API.getDownloadTracks(trackId).then((res) => {
//       if (res?.audiofile !== undefined && res.audiofile !== null) {
//         setHdmp3File(res.audiofile.hd_mp3.url);
//         setOriginalFile(res.audiofile.original.url);
//         setShowDownloadModal(currentTarget);
//       } else {
//         Helper.handleError(res);
//       }
//     });
//   };

//   const handleDownloadArchive = (trackId, quality) => {
//     API.downloadArchiveTrack(trackId, quality).then((res) => { });
//   };

//   const handleArchiveDownload = (trackId, quality) => {
//     API.downloadArchiveTrack(trackId, quality).then((res) => {
//       if (Array.isArray(res) && res.length) {
//         toast(({ closeToast }) => (
//           <SuccessToast message="Check your email, you have been sent a link to download the files." />
//         ));
//       } else {
//         toast(({ closeToast }) => <ErrorToast message={res.message} />);
//       }
//     });
//   };

//   const setDownloadHistory = (trackId) => {
//     API.setDownloads(trackId).then((res) => {
//       const downloadlist = JSON.parse(localStorage.getItem("download"));
//       downloadlist.push(trackId);
//       setDownload(downloadlist);
//       localStorage.setItem("download", JSON.stringify(downloadlist));
//     });
//   };
  
//   const closeProjectModal = () => {
//     setShowProjectModal(false);
//     setLoaderAddTrackToProject(false);
//   };

//   const handleProjectModal = (trackId) => {
//     if (!trackContext.validateUser(Constants.ACTION.ADD_TO_PROJECT)) {
//       trackContext.setShowSubscribePopup(true);
//       trackContext.setUserAction(Constants.ACTION.ADD_TO_PROJECT);
//       return;
//     }

//     setTrackToBeAddedToProject(trackId);
//     setShowProjectModal(true);
//   };

//   const handleThumbPrintSearch = async(props) => {
//     let filter = trackContext.trackFilter
//     filter.selectedChildTags = []
//     filter.selectedTags = []
//     filter.url = ""
//     filter.searchId = "";
//     filter.fileName = "";
//     filter.searchText = "";
//     filter.searchTitle = props.currentTrackDetail.title;
    
//     trackContext.setTrackFilter(filter);
//     localStorage.setItem("filter_music", JSON.stringify(filter))
//     trackContext.setShowLoaderMagic(true);
//     trackContext.setTrackData([]);
    
//     if(trackContext.path.startsWith("/search") ||
//       trackContext.path === "/" || 
//       trackContext.path.startsWith("/albums") ||
//       trackContext.path.startsWith("/artist") || 
//       trackContext.path.startsWith("/playlists"))
//     {
//       history.push(`/search/track/`); 
//     }
    
//     let reqObj = {  
//       url: 'public/search', 
//       method: 'post', 
//       data: {
//         "query": "",
//         "options": {
//           "trackId": props.currentTrackDetail.id,
//           "filters": {
//             exclude: [],
//             ...trackContext.trackFilter.searchTags,
//           },
//           "size": Constants.MEWO_TRACK_SEARCH_BATCH_SIZE,
//           "search_descriptions": trackContext.searchDescription ? trackContext.searchDescription : false
//         }
//       }
//     };
    
//     await MewoService.loadMewoData(reqObj).then(res => {
//       if (res?.hits) {
//         let newRes = res.hits.filter(
//           (item) => item.id !== props.currentTrackDetail.id
//         );
//         trackContext.setIsLoading(false);
//         trackContext.setTrackData(newRes);
//         trackContext.setTotaltracks(res.total.value);
//       } else {
//         Helper.handleError(res);
//       }
//     }).catch(err => {
//       toast(({ closeToast }) => (
//         <ErrorToast message={"Similarity Search Error: " + err?.response?.data?.message} />
//       ));
//     });
    
//     trackContext.setShowLoaderMagic(false);
//   };

//   const handleAddTrackToFavorites = (trackId) => {
//     if (!trackContext.validateUser(Constants.ACTION.FAVOURITE)) {
//       trackContext.setShowSubscribePopup(true);
//       trackContext.setUserAction(Constants.ACTION.FAVOURITE);
//       return;
//     }

//     API.addTrackToFavorites(trackId).then((res) => {
//       if (res?.success) {
//         localStorage.setItem("favs", JSON.stringify(res.favorites));
//         setIsFav(true);
//       } else {
//         Helper.handleError(res);
//       }
//     });
//   };

//   const playNextPrevious = (skip) => {
//     let playper =
//       (Amplitude.getSongPlayedPercentage() / 100) *
//       trackContext.currentTrackDetail.duration;
//     let duration = playper + skip;
//     let playerState = Amplitude.getPlayerState();
//     let per = (duration / trackContext.currentTrackDetail.duration) * 100;
    
//     if (playerState === "playing" && per < 100) {
//       Amplitude.setSongPlayedPercentage(duration < 0 ? 0.1 : per);
//     } else {
//       Amplitude.skipTo(
//         per >= 100
//           ? trackContext.currentTrackDetail.duration
//           : per < 0
//           ? 0
//           : duration,
//         0,
//         null
//       );
//       trackContext.setPlayPause(false);
//       Amplitude.stop();
//     }
//   };

//   const handleTrackDetail = () => {
//     setTrackDetail(true);
//     let body = document.getElementsByTagName("body");
//     let navTag = document.getElementsByTagName("nav");
//     if (navTag && navTag.length > 0) {
//       navTag[0].style.zIndex = 10;
//     }
//     if (body && body.length > 0) {
//       body[0].style.overflow = "hidden";
//     }
//   };

//   const CloseTrackDetail = () => {
//     setTrackDetail(false);
//     let body = document.getElementsByTagName("body");
//     let navTag = document.getElementsByTagName("nav");
//     if (navTag && navTag.length > 0) {
//       navTag[0].style.zIndex = 20;
//     }
//     if (body && body.length > 0) {
//       body[0].style.overflow = "auto";
//     }
//   };

//   const handleLoaderWithThumbPrint = () => {
//     setShowLoader(true)
//     trackContext.setClearData(true)
//     handleThumbPrintSearch(props)
//     trackContext.setClearData(false)

//     setTimeout(() => {
//       setShowLoader(false);
//     }, 4000)
//   }

//   const handleMagicWandClick = (trackData) => {
//     const tempFilter = CookieManager.getCookie("harmix-music-filter")?.length > 0 
//       ? JSON.parse(CookieManager.getCookie("harmix-music-filter")) 
//       : { "searchText": "", "type": Constants.SEARCH_TYPE.text};
    
//     tempFilter.type = Constants.SEARCH_TYPE.track;
//     tempFilter.searchText = trackData.title;
//     tempFilter.searchRef = trackData.id;
//     tempFilter.segment = null;
//     CookieManager.setCookie("harmix-music-filter", JSON.stringify(tempFilter));
//     history.push(`/library/${trackData.id}`)
//   }
//    const togglePlayer = () => {
//     setIsOpen(!isOpen);
//   };

//   return (
//     <>
//       {currentTrack !== "" && (
//         <div className="player-wrapper bg-white shadow-md p-4 md:p-6 text-sm md:text-base">
//           {/* Top Time & Waveform */}
//           <div className="bg-gray-100 lg:hidden flex rounded-md px-4 overflow-hidden py-4 mb-4">
//             <div className="w-full flex flex-col md:flex-row justify-center items-center gap-3 md:gap-6">
//               <div className="flex-1 w-full md:w-auto" id="progress-container">
//                 <div className="amplitude-wave-form h-1 bg-gray-300 rounded-full"></div>
//                 <input type="range" className="amplitude-song-slider w-full" />
//                 <progress id="song-played-progress" className="amplitude-song-played-progress w-full" />
//                 <progress id="song-buffered-progress" value="0" className="amplitude-buffered-progress hidden" />
//               </div>
//             </div>
//           </div>

//           {/* Player Controls & Track Info */}
//           <div className="flex md:flex-row items-center gap-4 md:gap-6">
//             {/* Album Art */}
//             <Link to={`/album/${trackContext.currentTrackDetail.album?.id}`} className="w-full md:w-auto">
//               <img
//                 src={trackContext.currentTrackDetail.album?.image?.original?.url || defaultImage}
//                 alt="Album"
//                 className="w-12 h-12 object-cover rounded-md shadow hidden sm:block mx-auto"
//                 onError={(e) => trackContext.setDefaultImage(e)}
//               />
//             </Link>

//             {/* Track Info and Controls */}
//             <div className="flex md:flex-1 justify-center items-center md:items-start w-full">
//               <div className="mb-2 w-full text-center md:text-left">
//                 <div data-amplitude-song-info="name" className="text-base font-semibold text-black truncate">
//                   {trackContext.currentTrackDetail.title}
//                 </div>
//                 <div data-amplitude-song-info="artist" className="text-sm text-gray-600 truncate">
//                   {trackContext.currentTrackDetail.artist}
//                 </div>
//               </div>

//               {/* Player Controls */}
//             <div className="flex items-center justify-center sm:justify-start gap-3 mt-2 w-full">
//   <div
//     onClick={() => handlePlayPrevNextTrack("prev")}
//     className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition cursor-pointer"
//   >
//     <SkipPrevious className="w-4 h-4" />
//   </div>

//   <div
//     onClick={() => playNextPrevious(-10)}
//     className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition cursor-pointer"
//   >
//     <Rewind className="w-4 h-4" />
//   </div>

//   <div
//     onClick={handlePlayOrPause}
//     className="w-10 h-10 flex items-center justify-center rounded-full text-white  transition cursor-pointer"
//   >
//     {trackContext.playPause ? (
//       <Pause className="w-5 h-5" />
//     ) : (
//       <Play className="w-5 h-5" />
//     )}
//   </div>

//   <div
//     onClick={() => playNextPrevious(10)}
//     className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition cursor-pointer"
//   >
//     <Skip className="w-4 h-4" />
//   </div>

//   <div
//     onClick={() => handlePlayPrevNextTrack("next")}
//     className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition cursor-pointer"
//   >
//     <SkipNext className="w-4 h-4" />
//   </div>
// </div>

//             </div>
// <div>
//   <span className="current-time font-light text-ctaRed">
//                       <span className="amplitude-current-minutes"></span>:
//                       <span className="amplitude-current-seconds"></span>
//                     </span>
//                     <span className="ml-1 mr-1">/</span>
//    <span className="duration">
//                       <span className="amplitude-duration-minutes"></span>:
//                       <span className="amplitude-duration-seconds"></span>
//                     </span>
// </div>
//             {/* Volume + Favorites + Options */}
//             <div className="hidden lg:flex justify-end items-center gap-8 text-gray-700 text-sm">
//               {/* Volume Controls - Fixed implementation */}
//               <div className="flex items-center gap-4">
//                 {/* Mute Button */}
//                 <div 
//                   onClick={handleMute}
//                   className="w-6 h-6 text-gray-600 cursor-pointer transition-all flex items-center justify-center"
//                 >
//                   {isMuted || currentVolume === 0 ? (
//                     <VolumeOff className="text-gray-400" />
//                   ) : (
//                     <VolumeUp className="text-gray-600" />
//                   )}
//                 </div>

//                {/* Volume Slider */}
// <input
//   type="range"
//   min="0"
//   max="100"
//   value={currentVolume}
//   onChange={handleVolumeChange}
//   className="w-24 h-1 bg-gray-300 rounded-full cursor-pointer"
//   style={{ accentColor: 'black' }}
// />
//                 {/* Shuffle Button */}
//               </div>

//               {/* Action Icons */}
//               <div className="flex items-center gap-4 text-xl">
//                 <ThumbPrint
//                   onClick={() =>
//                     handleMagicWandClick({
//                       title: trackContext.currentTrackDetail.display_title,
//                       id: trackContext.currentTrackDetail.id,
//                     })
//                   }
//                   className="cursor-pointer text-gray-600 hover:text-indigo-600 transition-all"
//                 />

//                 {isFav ? (
//                   <FavoriteIcon
//                     onClick={() => handleAddTrackToFavorites(props.currentTrackDetail.id)}
//                     className="text-red-500 cursor-pointer hover:scale-110 transition-all"
//                   />
//                 ) : (
//                   <UnFavoriteIcon
//                     onClick={() => handleAddTrackToFavorites(props.currentTrackDetail.id)}
//                     className="text-gray-500 hover:text-red-500 cursor-pointer hover:scale-110 transition-all"
//                   />
//                 )}

//                 <CreateNewFolderIcon
//                   onClick={() => handleProjectModal(props.currentTrackDetail.id)}
//                   className="cursor-pointer text-gray-600 hover:text-blue-500 transition-all"
//                 />

//                 {download ? (
//                   <Activedownload
//                     onClick={(e) => handleDownloadTrack(e, props.currentTrackDetail.id)}
//                     className="cursor-pointer text-blue-600 hover:text-blue-800 transition-all"
//                   />
//                 ) : (
//                   <GetAppIcon
//                     onClick={(e) => handleDownloadTrack(e, props.currentTrackDetail.id)}
//                     className="cursor-pointer text-gray-500 hover:text-blue-500 transition-all"
//                   />
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Loader */}
//           {showLoader && (
//             <div className="mt-4 text-center text-sm text-gray-600">
//               <p className="mb-2">This is Maya, your self-learning neural engine. I am searching the most relevant tracks for you</p>
//               <img src={RippleLoader} alt="loading..." className="mx-auto" />
//             </div>
//           )}

//           {/* Modals */}
//           {showProjectModal && (
//             <AddTrackToProjectPopup
//               trackToBeAddedToProject={trackToBeAddedToProject}
//               closeProjectModal={closeProjectModal}
//             />
//           )}
//           {showTrackDetail && (
//             <TrackDetail
//               currentTrackDetail={props}
//               handleProjectModal={handleProjectModal}
//               CloseTrackDetail={CloseTrackDetail}
//             />
//           )}
//         </div>
//       )}
//     </>


//   );
// }